import * as React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useContactModal } from "../context/contactModal";
import { COMPANY } from "../data/company";
export const ContactModal = ({ isOpen, onClose }) => {
  const { inquiry } = useContactModal();
  const r = React.useRef(null);
  React.useEffect(() => {
    var h;
    if (!isOpen) {
      return;
    }
    const u = document.activeElement;
    const f = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    if ((h = r.current) != null) {
      h.focus();
    }
    const d = (g) => {
      var m;
      if (g.key === "Escape") {
        onClose();
      }
      if (g.key !== "Tab") {
        return;
      }
      const x =
        (m = r.current) == null
          ? undefined
          : m.querySelectorAll("button:not(:disabled), input, textarea, a[href]");
      if (x == null || !x.length) {
        return;
      }
      const w = x[0];
      const k = x[x.length - 1];
      if (g.shiftKey && (document.activeElement === w || document.activeElement === r.current)) {
        g.preventDefault();
        k.focus();
      } else if (!g.shiftKey && document.activeElement === k) {
        g.preventDefault();
        w.focus();
      }
    };
    document.addEventListener("keydown", d);
    return () => {
      document.body.style.overflow = f;
      document.removeEventListener("keydown", d);
      if (u != null) {
        u.focus();
      }
    };
  }, [isOpen, onClose]);
  React.useState("");
  React.useState("+1");
  const [i, o] = React.useState(false);
  const [s, l] = React.useState(false);
  const c = async (u) => {
    u.preventDefault();
    if (i) {
      return;
    }
    o(true);
    const f = u.currentTarget;
    const d = new FormData(f);
    const h = {
      profile: d.get("profile"),
      email: d.get("email"),
      message: [
        inquiry ? `${inquiry.intent}: ${inquiry.product}` : "",
        d.get("quantity") ? `Estimated quantity: ${d.get("quantity")}` : "",
        d.get("message"),
      ].filter(Boolean).join(`

`),
    };
    try {
      const g = await fetch("https://formmail.actriumaiworkers.workers.dev", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(h),
      });
      const x = await g.json().catch(() => ({}));
      if (g.ok) {
        alert("Your inquiry has been sent successfully.");
        f.reset();
        onClose();
      } else {
        console.error("Worker Error:", x);
        alert(`Submission failed: ${x.error || "Check your Resend DNS settings"}`);
      }
    } catch (g) {
      console.error("Network Error:", g);
      alert("Network error, please try again later.");
    } finally {
      o(false);
    }
  };
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-4 touch-none"
          onClick={onClose}
          style={{
            overscrollBehavior: "contain",
          }}
        >
          <motion.div
            ref={r}
            role="dialog"
            aria-modal="true"
            aria-labelledby="inquiry-title"
            tabIndex={-1}
            initial={{
              opacity: 0,
              scale: 0.95,
              y: 20,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              scale: 0.95,
              y: 20,
            }}
            transition={{
              duration: 0.2,
            }}
            className="bg-white rounded-xl shadow-2xl w-[calc(100%-2rem)] max-w-lg max-h-[85vh] overflow-y-auto touch-auto"
            onClick={(u) => u.stopPropagation()}
            style={{
              maxHeight: "85vh",
              overscrollBehavior: "contain",
            }}
          >
            <div className="p-4 md:p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 id="inquiry-title" className="text-xl font-semibold text-[#131313]">
                  {(inquiry == null ? undefined : inquiry.intent) || "Discuss Your Project"}
                </h3>
                <button
                  onClick={onClose}
                  aria-label="Close inquiry"
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
              <form className="space-y-4" id="contactForm" onSubmit={c}>
                {inquiry && (
                  <p className="border-l-2 border-[#006AFF] pl-3 text-base text-[#131313]">
                    Product: <strong>{inquiry.product}</strong>
                  </p>
                )}
                <div>
                  <label htmlFor="inquiry-profile" className="block text-base font-medium mb-2 text-gray-700">
                    Name / Organization *
                  </label>
                  <input
                    id="inquiry-profile"
                    type="text"
                    name="profile"
                    placeholder="Your name and organization"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#006AFF] text-base text-[#131313]"
                    required={true}
                  />
                </div>
                <div>
                  <label htmlFor="inquiry-email" className="block text-base font-medium mb-2 text-gray-700">
                    Work Email *
                  </label>
                  <input
                    id="inquiry-email"
                    type="email"
                    name="email"
                    placeholder="you@company.com"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#006AFF] text-base text-[#131313]"
                    required={true}
                  />
                </div>
                {inquiry && (
                  <div>
                    <label
                      htmlFor="inquiry-quantity"
                      className="block text-base font-medium mb-2 text-gray-700"
                    >
                      Estimated Quantity
                    </label>
                    <input
                      id="inquiry-quantity"
                      type="number"
                      name="quantity"
                      min="1"
                      step="1"
                      placeholder="Optional"
                      className="w-full px-4 py-3 border border-gray-300 rounded-md text-base text-[#131313]"
                    />
                  </div>
                )}
                <div>
                  <label htmlFor="inquiry-message" className="block text-base font-medium mb-2 text-gray-700">
                    Your Requirements *
                  </label>
                  <textarea
                    id="inquiry-message"
                    name="message"
                    placeholder="Tell us about your task, configuration and timeline."
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#006AFF] h-28 text-base resize-none text-[#131313]"
                    required={true}
                  />
                </div>
                <button
                  type="submit"
                  disabled={i}
                  className="w-full px-6 py-4 rounded-lg font-bold transition-all duration-300 bg-black text-white hover:bg-gray-800 text-base disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {i ? "Sending..." : "Send Inquiry"}
                </button>
              </form>
              {s && (
                <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-black text-white px-6 py-3 rounded-lg shadow-lg z-[100] animate-fade-in">
                  <p className="text-base font-medium">
                    Application submitted. Our team will review your professional profile and respond within
                    24 hours.
                  </p>
                </div>
              )}
              <div className="mt-6 border-t border-gray-200 pt-4">
                <p className="text-base font-semibold text-[#131313]">{COMPANY.legalName}</p>
                <address className="not-italic text-base leading-relaxed text-gray-500">
                  {COMPANY.addressLine1}
                  <br />
                  {COMPANY.addressLine2}
                </address>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
